import React from 'react';
import { LIST_COLORS, getColorComment } from '../utils/colorUtils';
import './CreateListForm.css'; // Reuse the same CSS

interface ColorPickerProps {
  selectedColor: string | null;
  onColorChange: (color: string) => void;
  showComment?: boolean;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ 
  selectedColor, 
  onColorChange, 
  showComment = true
}) => {
  return (
    <div className="form-group">
      <label className="color-picker-label">
        Choose a color
      </label>
      <div className="color-picker-grid">
        {/* First row - 5 colors */}
        <div className="color-row">
          {LIST_COLORS.slice(0, 5).map((color) => (
            <button
              key={color.value}
              type="button"
              className={`color-option ${selectedColor === color.value ? 'selected' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => onColorChange(color.value)}
              title={color.name}
            >
              {selectedColor === color.value && (
                <span className="color-check">✓</span>
              )}
            </button>
          ))}
        </div>
        
        {/* Second row - 4 colors */}
        <div className="color-row">
          {LIST_COLORS.slice(5, 9).map((color) => (
            <button
              key={color.value}
              type="button"
              className={`color-option ${selectedColor === color.value ? 'selected' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => onColorChange(color.value)}
              title={color.name}
            >
              {selectedColor === color.value && (
                <span className="color-check">✓</span>
              )}
            </button>
          ))}
        </div>
        
        {/* Third row - 3 colors */}
        <div className="color-row">
          {LIST_COLORS.slice(9, 12).map((color) => (
            <button
              key={color.value}
              type="button"
              className={`color-option ${selectedColor === color.value ? 'selected' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => onColorChange(color.value)}
              title={color.name}
            >
              {selectedColor === color.value && (
                <span className="color-check">✓</span>
              )}
            </button>
          ))}
        </div>
      </div>
      
      {/* Color comment - only show when a color is selected */}
      {showComment && selectedColor && (
        <div className="color-comment">
          {getColorComment(selectedColor)}
        </div>
      )}
    </div>
  );
};
